
export function layout($,imagesLoaded) {

  
  $('html').addClass('htmlReady');
  
  /*imagesLoaded( 'body', { background: true }, function() {
  });*/

  /*document.fonts.ready.then(function () {

  });*/

  //----------------------------------------------------
  // Inline anchors
  //----------------------------------------------------

  $('a[href^="#"]').click(function(e) {
  	e.preventDefault();
  	let target = $(this).attr('href');
  	$('html, body').animate({
  		scrollTop : $(target).offset().top - 100
  	}, 500);
  });

}
